export default __webpack_public_path__ + "static/media/clickPokemonSound.499de0f6.mp3";